import axios from 'axios';

export const getAllCustomersApi = async () => {
  const response = await axios.get(`/admin/customer`);
  return response.data;
};

export const getCustomerProfilesApi = async () => {
  const response = await axios.get(`/admin/customer-profiles`);
  return response.data;
};

export const getPerforamceCustomerListApi = async () => {
  const response = await axios.get(`/admin/performance-customer-list`);
  return response.data;
};

export const getFundingCustomerListApi = async () => {
  const response = await axios.get(`/admin/funding-customer-list`);
  return response.data;
};

export const getCustomerFundingApi = async (customerId) => {
  const response = await axios.get(`/admin/customer/${customerId}/funding`);
  return response.data;
};

export const getCustomerFundingSimApi = async (customerId, data) => {
  const response = await axios.post(
    `/admin/customer/${customerId}/funding-sim`,
    data
  );
  return response.data;
};

export const getCustomerFundingLossSimApi = async (customerId, data) => {
  const response = await axios.post(
    `/admin/customer/${customerId}/funding-loss-sim`,
    data
  );
  return response.data;
};

export const createUserAndCustomerApi = async ({
  email,
  companyName,
  tenant,
  googleDrivePath,
}) => {
  const response = await axios.post(`/admin/customer/user`, {
    email: email || undefined,
    companyName,
    tenant: tenant || 'Twelve',
    googleDrivePath: googleDrivePath || undefined,
  });
  return response.data;
};

export const updateCustomerTenantApi = async (customerId, tenant) => {
  const response = await axios.put(`/admin/customer/${customerId}/tenant`, {
    tenant,
  });
  return response.data;
};

export const createUserForExistingCustomerApi = async ({
  customerId,
  email,
}) => {
  const response = await axios.post(`/admin/customer/${customerId}/user`, {
    email,
  });
  return response.data;
};

export const getCustomerUsersApi = async (customerId) => {
  const response = await axios.get(`/admin/customer/${customerId}/users`);
  return response.data;
};

export const getCockpitUsersApi = async () => {
  const response = await axios.get(`/admin/users`);
  return response.data;
};

export const getCompanyRankListApi = async () => {
  const response = await axios.get(`/admin/company-rank-list`);
  return response.data;
};

export const deleteCustomerApi = async (customerId) => {
  const response = await axios.delete(`/admin/customer/${customerId}`);
  return response.data;
};

export const deleteCustomerUserApi = async (customerId, userId) => {
  const response = await axios.delete(
    `/admin/customer/${customerId}/user/${userId}`
  );
  return response.data;
};
